import { Injectable } from '@angular/core';
import {AuthService} from "./auth.service";
import {User} from "../definitions";
import {IDocument} from "../interfaces/document.definition";
import {paramsHelper} from "../helpers/params-helper";
import {E_ENDPOINTS} from "../helpers/params/loader-params";
import {Http} from "@angular/http";
import {PreloaderService} from "./preloader.service";
import {LoaderService} from "./loader.service";
import {ErrorService} from "./error.service";
import {isArray} from "util";
import {query} from "../helpers/jp";

@Injectable()
export class HistoryService extends LoaderService{

  private user:User;

  constructor(protected authService:AuthService,
              protected http: Http,
              protected errorService: ErrorService,
              protected preloaderService: PreloaderService) {
    super(http, errorService, preloaderService);
    this.authService
      .authenticated()
      .subscribe((user: User) => this.user = user);
  }

  addCheckpoint(message)
  {
    let checkpoint = {objType:'checkpoint', objName:message, timestamp: Date.now(), author:this.user.displayName};
    console.log(`checkpoint ${message}`);
    let params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.HISTORY);
    return this.sendPost(params.createEndpointUrl("/addCheckpoint"), checkpoint);
  }

  saveHistory(document:IDocument)
  {
    let record = this.generateRecord(document);
    let params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.HISTORY);

    this.sendPost(params.createEndpointUrl("/saveOne"), record).subscribe(()=>{console.log('history saved')});
  }

  clearHistory(dbIds?:string[])
  {
    //console.log(dbIds);
    let params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.HISTORY);

    return this.sendPost(params.createEndpointUrl("/removeMany"), dbIds);//.subscribe(()=>{console.log('history cleared')});
  }

  private generateRecord(document:IDocument):IHistoryRecord
  {
    let record =
      {
        timestamp: Date.now(),
        objDBId: document._id,
        objId: document.id,
        objType: document._type,
        objName: this.getObjName(document),
        author: this.user.displayName
      }

    return record;
  }

  private getObjName(document:any):string
  {
    if (document['name'] != null)
    {
      return document['name'];
    }
    if (document['codeName'] != null)
    {
      return document['codeName'];
    }
    return query(document, "locales.ru.[key=name].value.0");
  }

  private traceRecord(record:IHistoryRecord)
  {
    console.log(record);
  }
}

export interface IHistoryRecord {
  timestamp: number;
  objDBId: string;
  objId: number;
  objType: string;
  objName: string;
  author: string;
}





// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/history.service.ts